<template>
  <div class="step_three">
    <svg class="icon icona_xiadan_chenggong" aria-hidden="true">
      <use xlink:href="#icona_xiadan_chenggong" />
    </svg>
    <div class="pay_success">支付成功</div>
    <div class="phone_open">请保持手机畅通</div>
    <div class="pay_mode_success">
      支付方式：
      <span>余额支付</span>
    </div>
    <div class="pay_money_success">
      支付金额：
      <span>¥{{ $store.state.priceList.totalFee }}</span>
    </div>
    <div class="success_btns">
      <el-button class="goback" @click="goBack()">返回首页</el-button>
      <el-button class="goback" @click="openOrder()">查看订单</el-button>
      <!--<el-button class="seeorder" @click="placeOrder()">继续下单</el-button>-->
    </div>
  </div>
</template>

<script>
import Bus from "./../../utils/bus.js";
export default {
  data() {
    return {};
  },
  activated() {
    var data = {
      url: "stepThree",
      step: 3,
      finish:'finish'
    };
    Bus.$emit("val", data);
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/user/index" });
    },
    openOrder() {
      this.$router.push({ path: "/user/order" });
    },
    placeOrder() {
      this.$router.push({
        name: "stepOne",
        params: { continue: 1 }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.step_three {
  background: #ffffff;
  padding: 50px 0;
  margin-top: 15px;
  .icona_xiadan_chenggong {
    width: 114px;
    height: 114px;
    color: #63cf4e;
    display: block;
    margin: 0 auto;
  }
  .pay_success {
    color: #2f3133;
    font-size: 22px;
    height: 22px;
    line-height: 1;
    margin-top: 20px;
    text-align: center;
  }
  .phone_open {
    color: #5e6066;
    font-size: 12px;
    height: 12px;
    line-height: 1;
    margin-top: 12px;
    text-align: center;
  }
  .pay_mode_success,
  .pay_money_success {
    font-size: 12px;
    height: 12px;
    line-height: 1;
    color: #5e6066;
    text-align: center;
    margin-top: 30px;
    span {
      color: #f75658;
    }
  }
  .pay_money_success {
    margin-top: 12px;
  }
  .success_btns {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .goback {
      width: 190px;
      height: 46px;
      border-radius: 2px;
      border: 1px solid rgba(144, 147, 153, 1);
      background: #ffffff;
      font-size: 20px;
      color: #5e6066;
    }
    .seeorder {
      width: 190px;
      height: 46px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      font-size: 20px;
      color: #ffffff;
      border-color: #3455d3;
    }
    .seeorder:hover {
      background: #2c4abb;
      border-color: #2c4abb;
    }
    .goback:hover {
      border-color: #3455d3;
      color: #3455d3;
    }
  }
}
</style>
